import { render, staticRenderFns } from "./SolutionsTable.vue?vue&type=template&id=676ea368&"
import script from "./SolutionsTable.vue?vue&type=script&lang=js&"
export * from "./SolutionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SolutionsTable.vue?vue&type=style&index=0&id=676ea368&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports